/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.ts to modify the generation of this file.


import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-nextjs';

import { BYOCWrapper, FEaaSWrapper } from '@sitecore-jss/sitecore-jss-nextjs';

import * as AnchorNavigation from 'src/components/AnchorNavigation';
import * as Breadcrumb from 'src/components/Breadcrumb';
import * as Career from 'src/components/Career';
import * as ContactUs from 'src/components/ContactUs';
import * as Download from 'src/components/Download';
import * as DynamicLinkList from 'src/components/DynamicLinkList';
import * as Footer from 'src/components/Footer';
import * as Header from 'src/components/Header';
import * as Hero from 'src/components/Hero';
import * as IFrame from 'src/components/IFrame';
import * as ImageGallery from 'src/components/ImageGallery';
import * as PartialDesignDynamicPlaceholder from 'src/components/PartialDesignDynamicPlaceholder';
import * as Partner from 'src/components/Partner';
import * as PartnersFilter from 'src/components/PartnersFilter';
import * as ScriptEmbed from 'src/components/ScriptEmbed';
import * as SearchBox from 'src/components/SearchBox';
import * as SearchResults from 'src/components/SearchResults';
import * as Showcase from 'src/components/Showcase';
import * as SpeakerList from 'src/components/SpeakerList';
import * as SponsorList from 'src/components/SponsorList';
import * as Video from 'src/components/Video';
import * as Accordion from 'src/components/Accordion/Accordion';
import * as AccordionElement from 'src/components/Accordion/AccordionElement';
import * as ArticleListCard from 'src/components/ArticleListCarousel/ArticleListCard';
import * as ArticleListCarousel from 'src/components/ArticleListCarousel/ArticleListCarousel';
import * as BreakoutSessionAccordion from 'src/components/BreakoutSessionAccordion/BreakoutSessionAccordion';
import * as BreakoutSessionAccordionElement from 'src/components/BreakoutSessionAccordion/BreakoutSessionAccordionElement';
import * as Content from 'src/components/Content/Content';
import * as Image from 'src/components/Content/Image';
import * as RichText from 'src/components/Content/RichText';
import * as DigitsAndData from 'src/components/DigitsAndData/DigitsAndData';
import * as DigitsAndDataElement from 'src/components/DigitsAndData/DigitsAndDataElement';
import * as GridTeaserElement from 'src/components/GridTeaserList/GridTeaserElement';
import * as GridTeaserList from 'src/components/GridTeaserList/GridTeaserList';
import * as HeroCarousel from 'src/components/HeroCarousel/HeroCarousel';
import * as HeroCarouselElement from 'src/components/HeroCarousel/HeroCarouselElement';
import * as ImageCarousel from 'src/components/ImageCarousel/ImageCarousel';
import * as ImageCarouselElement from 'src/components/ImageCarousel/ImageCarouselElement';
import * as MainNavigation from 'src/components/MainNavigation/MainNavigation';
import * as QAElement from 'src/components/QAList/QAElement';
import * as QAList from 'src/components/QAList/QAList';
import * as Quote from 'src/components/Quote/Quote';
import * as QuoteElement from 'src/components/Quote/QuoteElement';
import * as TabElement from 'src/components/Tabs/TabElement';
import * as Tabs from 'src/components/Tabs/Tabs';

export const components = new Map();
components.set('BYOCWrapper', BYOCWrapper);
components.set('FEaaSWrapper', FEaaSWrapper);

components.set('AnchorNavigation', AnchorNavigation);
components.set('Breadcrumb', Breadcrumb);
components.set('Career', Career);
components.set('ContactUs', ContactUs);
components.set('Download', Download);
components.set('DynamicLinkList', DynamicLinkList);
components.set('Footer', Footer);
components.set('Header', Header);
components.set('Hero', Hero);
components.set('IFrame', IFrame);
components.set('ImageGallery', ImageGallery);
components.set('PartialDesignDynamicPlaceholder', PartialDesignDynamicPlaceholder);
components.set('Partner', Partner);
components.set('PartnersFilter', PartnersFilter);
components.set('ScriptEmbed', ScriptEmbed);
components.set('SearchBox', SearchBox);
components.set('SearchResults', SearchResults);
components.set('Showcase', Showcase);
components.set('SpeakerList', SpeakerList);
components.set('SponsorList', SponsorList);
components.set('Video', Video);
components.set('Accordion', Accordion);
components.set('AccordionElement', AccordionElement);
components.set('ArticleListCard', ArticleListCard);
components.set('ArticleListCarousel', ArticleListCarousel);
components.set('BreakoutSessionAccordion', BreakoutSessionAccordion);
components.set('BreakoutSessionAccordionElement', BreakoutSessionAccordionElement);
components.set('Content', Content);
components.set('Image', Image);
components.set('RichText', RichText);
components.set('DigitsAndData', DigitsAndData);
components.set('DigitsAndDataElement', DigitsAndDataElement);
components.set('GridTeaserElement', GridTeaserElement);
components.set('GridTeaserList', GridTeaserList);
components.set('HeroCarousel', HeroCarousel);
components.set('HeroCarouselElement', HeroCarouselElement);
components.set('ImageCarousel', ImageCarousel);
components.set('ImageCarouselElement', ImageCarouselElement);
components.set('MainNavigation', MainNavigation);
components.set('QAElement', QAElement);
components.set('QAList', QAList);
components.set('Quote', Quote);
components.set('QuoteElement', QuoteElement);
components.set('TabElement', TabElement);
components.set('Tabs', Tabs);

export const componentBuilder = new ComponentBuilder({ components });

export const moduleFactory = componentBuilder.getModuleFactory();
